// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

const getChattyUrl = (accessToken) => {
  // Get cable URL from Rails app_config (set in application.html.erb)
  const baseUrl = window.appconfig?.pepper_chat?.cable_url;

  if (!baseUrl) {
    console.error('Chat cable_url not configured in app_config. Check pepper_chat configuration.');
    return null;
  }

  // Add access token as query parameter if provided
  if (accessToken) {
    return `${baseUrl}?access_token=${accessToken}`;
  }
  return baseUrl;
}

// Don't create consumer immediately - will be created when chat initializes
let consumer = null;

export const createChatConsumer = (accessToken) => {
  if (!consumer) {
    const url = getChattyUrl(accessToken);
    if (!url) {
      return null;
    }
    consumer = createConsumer(url);
  }
  return consumer;
}

export const getConsumer = () => consumer;

export default { createChatConsumer, getConsumer };
